import React, { useContext, useState} from 'react'
import { Link, NavLink, useParams, useNavigate } from "react-router-dom";
import { Container, Modal, Button, Spinner } from "react-bootstrap";
import { CommunityContext } from './CommunityContext';
import {apiLeaveCommunity} from '../api/api';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Menu, MenuItem, Snackbar } from '@material-ui/core';
import loading_img from '../img/placeholder.png';

const CommunityNavbar = () => {
  let { id } = useParams()
  let currentPath = window.location.pathname
  let navigate = useNavigate()
  const [show, setShow] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const { communityData, userData, isLoaded } = useContext(CommunityContext)

  const handleClose = () => setShow(false)

  const handleShow = () => setShow(true)

  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  }

  const shareCommunity = () => {
    let url = `${window.location.host}/community/${id}` 
    navigator.clipboard.writeText(url)
    handleMenuClose()
    setSnackbarMessage("Community URL copied to clipboard")
    handleSnackbarOpen()
  }

  const handleLeave = async () =>{
    await apiLeaveCommunity(id);
    navigate('/')
  }

  const handleSnackbarOpen = () =>{
    setSnackbarOpen(true)
    setTimeout(() => setSnackbarOpen(false),5000)
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  }

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div id="community-header">
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        action={action}
      />
      {
        isLoaded?
        <img 
          id="banner-image" 
          alt="community banner" 
          src={communityData.image ? communityData.image: loading_img}
          onError={() => loading_img}
        />
        :<img
          id="banner-image" 
          alt="community banner"
          src={loading_img}
        />
      }

      <div id="community-info">
        {
          isLoaded?(
            <Container>
              <p id="title">{communityData.name}</p>
              <p id="member-count">{communityData.totalMembers} Members</p>
            </Container>
          ):
          <Container>
            <p id="title">....</p>
            <p id="member-count"> x Members</p>
          </Container>
        }
      </div>
      <div id="community-navbar">
        <Container style={{cursor:'default'}}>
            <NavLink to="overview" className={!(currentPath !== "/announcement" || currentPath!=="/discussion")? "active" : ""}>
              <div>Overview</div>
            </NavLink>
            <NavLink to="announcement" className={currentPath === "/announcement" ? "active" : ""}>
              <div>Announcement</div>
            </NavLink>
            <NavLink to="discussion" className={currentPath === "/discussion" ? "active" : ""}>
              <div>Discussion</div>
            </NavLink>
            {
              isLoaded && (
                <>
                  <div style={{float: "right", padding:"0"}}>
                    <MoreVertIcon data-testid="member-options" onClick={handleMenuClick} style={{ color: 'white' }}/>
                  </div>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <MenuItem onClick={shareCommunity}>Copy link</MenuItem>
                    {
                      userData.isAdmin ?
                        <MenuItem onClick={handleMenuClose}>
                          <Link to="settings" style={{ color: 'inherit', textDecoration: 'none'  }}>Settings</Link>
                        </MenuItem>
                      :(
                        <MenuItem onClick={handleShow}>Leave</MenuItem>
                      )
                    }
                  </Menu>
                </>
                  
              )
            }
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Are you sure you want to leave?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                No
              </Button>
              <Button variant="primary" onClick={() => {handleLeave(id)}}>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </div>
  )
}

export default CommunityNavbar